import Header from './../../../components/Header/BarOther.vue';
import FooterOther from './../../../components/Footer/FooterOther.vue';

import api from '../../../js/api.js';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  name: 'mainww',
  components: { Header, FooterOther },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  data() {
    return {
      info: {
        name: '',
        email: '',
        msg: '',
      },
      cardList: [
        {
          id: 1,
          path: './../../../assets/imgs/1.jpg',
        },
        {
          id: 2,
          path: 'https://static.wixstatic.com/media/a3c153_4af4965eb5964cee8f034adadc6283d4~mv2.jpg/v1/fill/w_1898,h_1083,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/a3c153_4af4965eb5964cee8f034adadc6283d4~mv2.jpg',
        },
        {
          id: 3,
          path: 'https://static.wixstatic.com/media/a3c153_32715bc9b4ca4bf28818db9b91aa78ab~mv2.jpg/v1/fill/w_1898,h_1083,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/a3c153_32715bc9b4ca4bf28818db9b91aa78ab~mv2.jpg',
        },
      ],
    };
  },
  mounted() {},
  methods: {
    //  keepTimes(e){ //节流函数，处理滚动到尾部不触发轮播事件
    //     if(this.$refs.mySwiper){
    //         let isEnd = this.$refs.mySwiper.swiper.isEnd
    //         if(isEnd){
    //             this.showFlag = false
    //         }else{
    //             let activeIndex = this.$refs.mySwiper.swiper.activeIndex
    //             if(activeIndex==0){ //排除第一轮，第一轮隐藏

    //             }else{
    //                 this.showFlag = true
    //             }
    //         }
    //     }
    // },
    goLogin() {},
    swiperchange(i) {
      console.log(100);
    },
  },
};
